import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.string.ends-with.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent as _defineComponent } from 'vue';
import { useAuth } from '@/plugins/auth';
import { useStore } from '@/store/useStore';
import { LabsWandhModelSelectionEnum } from 'wklr-backend-sdk/repos/labs';
export default /*#__PURE__*/_defineComponent({
  __name: 'model-option',
  setup: function setup(__props) {
    var auth = useAuth();
    var store = useStore();
    var quota = computed(function () {
      return store.state.persistent.labs.wandh.quota;
    });
    var selection = computed({
      get: function get() {
        return store.state.persistent.labs.wandh.inputQuery.selection;
      },
      set: function set(newVal) {
        store.commit('setLabsWandhInputQuery', _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery), {}, {
          selection: newVal
        }));
      }
    });
    var plan = auth.user.labsWandhPlan;
    var showAdvancedModelRemainingQuota = !!plan && plan.maxSearchBoost !== null;
    var advancedModelRemainingQuota = computed(function () {
      var _quota$value$remainin, _quota$value, _quota$value$remainin2;
      return (_quota$value$remainin = (_quota$value = quota.value) === null || _quota$value === void 0 ? void 0 : (_quota$value$remainin2 = _quota$value.remainingQuotaByModel.advanced.remainingQuota) === null || _quota$value$remainin2 === void 0 ? void 0 : _quota$value$remainin2.toLocaleString()) !== null && _quota$value$remainin !== void 0 ? _quota$value$remainin : '0';
    });
    var hasRemainingQuota = computed(function () {
      var _quota$value2, _quota$value3;
      return (
        // nullの場合は無制限なので常にtrue
        !!plan && plan.maxSearchTotal === null || quota.value && ((_quota$value2 = quota.value) === null || _quota$value2 === void 0 ? void 0 : _quota$value2.remainingQuotaByModel.standard.remainingQuota) !== null && ((_quota$value3 = quota.value) === null || _quota$value3 === void 0 ? void 0 : _quota$value3.remainingQuotaByModel.standard.remainingQuota) > 0
      );
    });
    var hasAdvancedModelRemainingQuota = computed(function () {
      var _quota$value4, _quota$value5;
      return (
        // nullの場合は無制限なので常にtrue
        !!plan && plan.maxSearchBoost === null || quota.value && ((_quota$value4 = quota.value) === null || _quota$value4 === void 0 ? void 0 : _quota$value4.remainingQuotaByModel.advanced.remainingQuota) !== null && ((_quota$value5 = quota.value) === null || _quota$value5 === void 0 ? void 0 : _quota$value5.remainingQuotaByModel.advanced.remainingQuota) > 0
      );
    });
    var handleClickModel = function handleClickModel(event) {
      selection.value = event.currentTarget.value;
    };
    var isNotWatsonOnly = computed(function () {
      return auth.permissions.labsQA;
    });
    onBeforeMount(function () {
      if (store.state.persistent.labs.wandh.inputQuery.model && store.state.persistent.labs.wandh.inputQuery.model.endsWith('_advanced')) {
        selection.value = LabsWandhModelSelectionEnum.Advanced;
        store.state.persistent.labs.wandh.inputQuery.model = null;
      }
      if (!selection.value || !hasAdvancedModelRemainingQuota.value) {
        selection.value = LabsWandhModelSelectionEnum.Standard;
      }
    });
    return {
      __sfc: true,
      auth: auth,
      store: store,
      quota: quota,
      selection: selection,
      plan: plan,
      showAdvancedModelRemainingQuota: showAdvancedModelRemainingQuota,
      advancedModelRemainingQuota: advancedModelRemainingQuota,
      hasRemainingQuota: hasRemainingQuota,
      hasAdvancedModelRemainingQuota: hasAdvancedModelRemainingQuota,
      handleClickModel: handleClickModel,
      isNotWatsonOnly: isNotWatsonOnly,
      LabsWandhModelSelectionEnum: LabsWandhModelSelectionEnum
    };
  }
});